
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1217_1520)"}},[_c('path',{attrs:{"d":"M0 0h30v6.7H0V0z","fill":"#ED1B3B"}}),_c('path',{attrs:{"d":"M0 6.7h30v6.7H0V6.7z","fill":"#fff"}}),_c('path',{attrs:{"d":"M0 13.3h30V20H0v-6.7z","fill":"#01A5E6"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1217_1520"}},[_c('rect',{attrs:{"width":"30","height":"20","rx":"3","fill":"#fff"}})])])])
          )
        }
      }
    